import { Component, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { lastValueFrom } from 'rxjs';
import {
  BfluenceIntegrityControllerService,
  DivergentSubscriberBenefit
} from 'src/app/admin-api';
import { TableColumn, TableComponent } from 'src/app/components/table';
import { AppDialogService } from 'src/app/services/dialog.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-divergent-subscriber-benefit',
  templateUrl: './divergent-subscriber-benefit.component.html',
  styleUrl: './divergent-subscriber-benefit.component.scss',
  providers: [ConfirmationService, MessageService]
})
export class DivergentSubscriberBenefitComponent {
  @ViewChild(TableComponent) table: TableComponent;

  columns: Array<TableColumn> = [
    new TableColumn('', '', false, 'checkbox'),
    new TableColumn('Nome', 'name', true, 'text'),
    new TableColumn(
      'SubscriberId',
      'subscriberId',
      true,
      'number',
      '/users/subscribers/',
      'subscriberId'
    ),
    new TableColumn('SubscriptionTypeId', 'subscriptionTypeId', true, 'number'),
    new TableColumn('BenefitSubsType', 'benefitSubsType', true, 'number'),
    new TableColumn('CouponId', 'couponId', true, 'number'),
    new TableColumn('CouponName', 'couponName', true, 'text')
  ];

  constructor(
    public bfluenceIntegrityService: BfluenceIntegrityControllerService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) {}

  markAsResolved(elements: Array<DivergentSubscriberBenefit>): void {
    this.confirmationService.confirm({
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      rejectButtonStyleClass: 'p-button-danger',
      message: 'Deseja ajustar estes benefícios?',
      header: 'Ajustar Benefícios',
      accept: async () => {
        LoaderService.showLoader();
        try {
          await lastValueFrom(
            this.bfluenceIntegrityService.fixDivergentSubscriberBenefit(
              elements
            )
          );
          await this.table.refresh(true);
          this.messageService.add({
            summary: 'Sucesso',
            detail: elements.length + ' marcado(s) como resolvido(s)',
            severity: 'success'
          });
          LoaderService.showLoader(false);
        } catch (error) {
          LoaderService.showLoader(false);
          AppDialogService.showErrorDialog(error);
        }
      }
    });
  }
}
